import Vue from 'vue'
import Router from 'vue-router'

import pageNotFound from '../views/pageNotFound'

import atmosphere from './atmosphere'
import amwayterms from './amwayterms'
import survey from './survey'
import salesdashboard from './salesdashboard'
import concierge from './concierge'
import nutrilite from './nutrilite'
import astation from './astation'
import readership from './readership'
import cardquiz from './cardquiz'
import couponsys from './couponsys'
import artistry from './artistry'
import taola from './taola'
import myprotein from './myprotein'
import nca from './nca'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    ...atmosphere,
    ...amwayterms,
    ...survey,
    ...salesdashboard,
    ...concierge,
    ...nutrilite,
    ...astation,
    ...readership,
    ...cardquiz,
    ...couponsys,
    ...artistry,
    ...taola,
    ...myprotein,
    ...nca,
    {
      path: '*',
      name: 'pageNotFound',
      component: pageNotFound
    },
    {
      path: '/',
      name: 'pageNotFound',
      component: pageNotFound
    },
  ]
})

const block_pages = ['/old']

router.beforeEach (function (to, from, next) {

  console.log(57, to, from)
  for ( let n in block_pages ) {
    if (to.path.indexOf(block_pages[n]) > -1) {
      // console.log("block page !!!", to.path.indexOf(block_pages[n]), to.path, block_pages[n])
      // next('/')
    }
  }
  // console.log("not block page !!!")
  next()

})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js